import React, { useState,useEffect } from "react";
import CtaLayout from "../components/CtaLayout";
import "../styles/common.css";
import "../styles/cta.css";


function CtaNomal() {

  return (
    <>
      <CtaLayout title="お問い合わせ" lead="CONTACT">
      <div className='cta-box__text'>
        <h3>課題抽出やWebサイト制作の目的整理からご相談ください。</h3>
        <p>初めてのサイト制作で何をすればいいかお困りのお客様も歓迎。<br />現状の課題抽出やサイトの目的の整理、サイトコンセプトの策定からお任せください。もちろん、Web集客の戦略設計を具現化するサイト構成、デザイン、機能面までご提案します。</p>
      </div>
    </CtaLayout>
    </>
  );
}

export default CtaNomal;
